import React from 'react'

export const PostmanAstronaut = React.memo<JSX.IntrinsicElements['svg']>(
  (props) => {
    return (
      <svg
        width="140"
        height="120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M39.4 46.662c3.87 4.01 9.42 7.82 18.75 11.22M35.2 41.583c.57.91.43.81 1.25 1.8M61.98 43.902c-4.24-1.45-10.99-4.32-15.52-9.94-.55-.68-2.19-2.31-2.76-2.81"
          stroke="#686868"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity=".3"
          d="M108.46 110.582c0 2.92-13.1 5.29-29.25 5.29s-29.25-2.37-29.25-5.29c0-1.46 2.77-2.82 8.06-3.68 1.08-.18.89 3.81 2.44 5.07 5.3 4.35 8.22 1.51 11.44-.27 1.52-.84 1.34-6.32 2.06-6.37 2.81-.16 2.15-.04 5.26-.04 1.5 0-.41.12 1.03.08.67-.02 0 5.38 3.76 6.48 1.09.32 3.66 1.87 5.98 1.73 1.94-.11 3.21-2.42 4.19-3.08.68-.45 1.32-4.41 2.07-4.33 8.26.94 12.21 2.51 12.21 4.41z"
          fill="#262626"
        />
        <path
          d="M76.27 49.832c10.654 0 19.29-8.636 19.29-19.29 0-10.653-8.636-19.29-19.29-19.29s-19.29 8.637-19.29 19.29c0 10.654 8.636 19.29 19.29 19.29zM58.19 57.752l.18 25.03.32 23.74a7.36 7.36 0 1014.72 0l1.17-15.83c.07-1.62.95-3.29 2.58-3.29 1.61 0 2.54 1.61 2.62 3.22l1.18 15.2a7.83 7.83 0 007.74 7.83c4.36.05 7.13-2.35 7-8.75l-.64-28.32M58.27 57.733s4.06-2.88 4.19-13.39M66.9 47.563s.95 8.38-8.37 12.69M87.39 46.553s1.25 11.92 6.86 16.68"
          stroke="#686868"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M97.52 48.633l.04-6.19a2.335 2.335 0 00-2.37-2.3l-2.09-.06M87.07 30.832c.19 6.05-6.32 12.84-14.6 13.1-8.28.26-15.2-6.12-15.38-12.17-.19-6.05 0-10.96 14.65-11.42 13.98-.42 15.14 4.44 15.33 10.49zM80.26 59.203v-4.21c0-.24.19-.43.43-.43h4.07c.24 0 .43.19.43.43v4.21M84.85 10.373l-.76 2.39"
          stroke="#686868"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity=".7"
          d="M88.353 8.575a2.69 2.69 0 00-1.626-3.44A2.69 2.69 0 0083.3 6.787a2.69 2.69 0 001.626 3.439 2.69 2.69 0 003.427-1.651z"
          fill="#FF6C37"
        />
        <path
          d="M88.353 8.575a2.69 2.69 0 00-1.626-3.44A2.69 2.69 0 0083.3 6.787a2.69 2.69 0 001.626 3.439 2.69 2.69 0 003.427-1.651zM95.5 27.472l2.71.98c.49.22.81.75.81 1.33v2.68c0 .65-.4 1.22-.97 1.39l-2.8.84M56.88 26.452l-2.64 1.21c-.49.22-.81.75-.81 1.33v2.68c0 .65.4 1.22.97 1.39l2.8.84"
          stroke="#686868"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity=".7"
          d="M36.53 41.873l-.12 3.31c0 .95.76 1.72 1.7 1.76.99.03 1.81-.76 1.82-1.75l-.18-3.09"
          fill="url(#paint0_linear)"
        />
        <path
          d="M36.53 41.873l-.12 3.31c0 .95.76 1.72 1.7 1.76.99.03 1.81-.76 1.82-1.75l-.18-3.09"
          stroke="#686868"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity=".7"
          d="M39.41 28.172l.05-1.26c1.42 0 2.67-.34 2.57-2.57l-1.12-8.83-.85 7.14-.78-.01-1.13-6.98-1.21 6.93h-.8l-.83-6.96-1 8.36c-.11 2.49 1.31 2.92 2.92 2.92l-.04 1.57"
          fill="url(#paint1_linear)"
        />
        <path
          d="M39.41 28.172l.05-1.26c1.42 0 2.67-.34 2.57-2.57l-1.12-8.83-.85 7.14-.78-.01-1.13-6.98-1.21 6.93h-.8l-.83-6.96-1 8.36c-.11 2.49 1.31 2.92 2.92 2.92l-.04 1.57M89.95 44.672s8.94 1.52 16.36 16.59c5.78 11.75-5.63 15.51-14.82 14.59-3.57-.36-7.98-3.05-7.59-6.62a6.53 6.53 0 016.49-5.82h9.46M95.99 63.322s-4.39-7.03-3.24-17.43M38.27 42.112a6.77 6.77 0 100-13.54 6.77 6.77 0 000 13.54z"
          stroke="#686868"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M78.49 62.512c7.5 0 13.58-.734 13.58-1.64 0-.905-6.08-1.64-13.58-1.64s-13.58.735-13.58 1.64c0 .906 6.08 1.64 13.58 1.64z"
          stroke="#686868"
          strokeWidth="1.026"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M85.34 72.882a13.602 13.602 0 01-6.82 1.82c-7.56 0-13.68-6.12-13.68-13.68M92.2 61.023c0 .89.01 1.33-.16 2.17"
          stroke="#686868"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M75.46 66.563l-2.87 1.58 2.79 1.34M79.59 69.483l2.87-1.58-2.79-1.34M77.97 65.862l-1.03 4.41"
          stroke="#686868"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity=".7"
          d="M78.35 62.042c6.335 0 11.47-.326 11.47-.73 0-.403-5.135-.73-11.47-.73-6.335 0-11.47.327-11.47.73 0 .404 5.135.73 11.47.73z"
          fill="url(#paint2_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="36.418"
            y1="44.41"
            x2="39.943"
            y2="44.41"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF7002" />
            <stop offset=".296" stopColor="#FE7304" />
            <stop offset=".5" stopColor="#FC7C0A" />
            <stop offset=".676" stopColor="#F88B15" />
            <stop offset=".836" stopColor="#F3A125" />
            <stop offset=".985" stopColor="#ECBD39" />
            <stop offset="1" stopColor="#EBC03B" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="34.314"
            y1="21.998"
            x2="42.038"
            y2="21.998"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF7002" />
            <stop offset=".296" stopColor="#FE7304" />
            <stop offset=".5" stopColor="#FC7C0A" />
            <stop offset=".676" stopColor="#F88B15" />
            <stop offset=".836" stopColor="#F3A125" />
            <stop offset=".985" stopColor="#ECBD39" />
            <stop offset="1" stopColor="#EBC03B" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="66.885"
            y1="61.309"
            x2="89.818"
            y2="61.309"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF7002" />
            <stop offset=".296" stopColor="#FE7304" />
            <stop offset=".5" stopColor="#FC7C0A" />
            <stop offset=".676" stopColor="#F88B15" />
            <stop offset=".836" stopColor="#F3A125" />
            <stop offset=".985" stopColor="#ECBD39" />
            <stop offset="1" stopColor="#EBC03B" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)
